// Recensioni multilingua (IT, EN, FR, ES, DE)
const ml = (it, en, fr, es, de) => ({ it, en, fr, es, de });

export const REVIEWS = [
  {
    name: "Marco R.", initials: "MR", stars: 5, whenKey: "weeks2",
    text: ml(
      "Pizza eccezionale, impasto leggerissimo e davvero digeribile. Si sente la qualità della farina e degli ingredienti. Locale curato, ci torneremo sicuramente.",
      "Exceptional pizza, very light and truly digestible dough. You can taste the quality of the flour and ingredients. Cared-for venue, we'll definitely come back.",
      "Pizza exceptionnelle, pâte très légère et vraiment digeste. On sent la qualité de la farine et des ingrédients. Lieu soigné, on reviendra sans hésiter.",
      "Pizza excepcional, masa muy ligera y muy digerible. Se nota la calidad de la harina y de los ingredientes. Local cuidado, volveremos seguro.",
      "Außergewöhnliche Pizza, sehr leichter und wirklich verdaulicher Teig. Man schmeckt die Qualität von Mehl und Zutaten. Gepflegtes Lokal, wir kommen sicher wieder."
    ),
  },
  {
    name: "Giulia B.", initials: "GB", stars: 5, whenKey: "month1",
    text: ml(
      "Personale gentile e accogliente, ci hanno fatto sentire a casa. La pizza Sofia è una poesia. Ottimo rapporto qualità-prezzo per Novara.",
      "Kind and welcoming staff, they made us feel at home. The Sofia pizza is poetry. Great value for Novara.",
      "Personnel gentil et accueillant, on s'est sentis comme à la maison. La pizza Sofia est un poème. Excellent rapport qualité-prix pour Novara.",
      "Personal amable y acogedor, nos hicieron sentir como en casa. La pizza Sofia es una poesía. Excelente relación calidad-precio para Novara.",
      "Freundliches und herzliches Personal, wir fühlten uns wie zu Hause. Die Sofia-Pizza ist ein Gedicht. Hervorragendes Preis-Leistungs-Verhältnis für Novara."
    ),
  },
  {
    name: "Andrea M.", initials: "AM", stars: 5, whenKey: "weeks3",
    text: ml(
      "Servizio veloce anche con il locale pieno. Cornicione ripieno fantastico. Anche i bambini hanno mangiato benissimo con il menu coniglietto.",
      "Fast service even when busy. The stuffed crust is fantastic. The kids also loved the bunny menu.",
      "Service rapide même avec le restaurant plein. La croûte farcie est fantastique. Les enfants ont aussi très bien mangé avec le menu lapin.",
      "Servicio rápido incluso con el local lleno. El borde relleno es fantástico. Los niños también comieron muy bien con el menú conejito.",
      "Schneller Service auch bei vollem Lokal. Der gefüllte Rand ist fantastisch. Auch die Kinder haben mit dem Häschenmenü hervorragend gegessen."
    ),
  },
  {
    name: "Chiara L.", initials: "CL", stars: 4, whenKey: "month1",
    text: ml(
      "Atmosfera tranquilla, perfetta per una serata in famiglia. Pizza vegetariana super, ingredienti freschissimi. Tornerò volentieri.",
      "Calm atmosphere, perfect for a family evening. Great vegetarian pizza, very fresh ingredients. I'll happily return.",
      "Atmosphère tranquille, parfaite pour une soirée en famille. Pizza végétarienne super, ingrédients très frais. Je reviendrai avec plaisir.",
      "Ambiente tranquilo, perfecto para una velada en familia. Pizza vegetariana genial, ingredientes muy frescos. Volveré con gusto.",
      "Ruhige Atmosphäre, perfekt für einen Familienabend. Super vegetarische Pizza, sehr frische Zutaten. Ich komme gerne wieder."
    ),
  },
  {
    name: "Davide T.", initials: "DT", stars: 5, whenKey: "days5",
    text: ml(
      "La lievitazione 36 ore si sente: pizza leggera, niente pesantezza. Birre ben selezionate. Una delle migliori pizzerie di Novara.",
      "You can taste the 36-hour leavening: light pizza, no heaviness. Well-selected beers. One of the best pizzerias in Novara.",
      "On sent la levée de 36 heures : pizza légère, aucune lourdeur. Bières bien choisies. L'une des meilleures pizzerias de Novara.",
      "Se nota la fermentación de 36 horas: pizza ligera, sin pesadez. Cervezas bien seleccionadas. Una de las mejores pizzerías de Novara.",
      "Man schmeckt die 36-stündige Gärung: leichte Pizza, keine Schwere. Gut ausgewählte Biere. Eine der besten Pizzerien in Novara."
    ),
  },
  {
    name: "Elena P.", initials: "EP", stars: 5, whenKey: "months2",
    text: ml(
      "Sapori autentici, prezzi onesti, accoglienza familiare. Da provare la 'Sofia' con tonno fresco e pistacchio — strepitosa.",
      "Authentic flavours, honest prices, family welcome. Must try the 'Sofia' with fresh tuna and pistachio — outstanding.",
      "Saveurs authentiques, prix honnêtes, accueil familial. À essayer la 'Sofia' au thon frais et pistache — époustouflante.",
      "Sabores auténticos, precios justos, acogida familiar. A probar la 'Sofia' con atún fresco y pistacho — espectacular.",
      "Authentische Aromen, faire Preise, familiärer Empfang. Probieren Sie die 'Sofia' mit frischem Thunfisch und Pistazie — herausragend."
    ),
  },
];
